import api from './api';

export const getMyWelcome = () => api.get('/welcome/me').then(r => r.data);
export const dismissMyWelcome = () => api.post('/welcome/me/dismiss').then(r => r.data);
export const getWelcomeSettings = () => api.get('/welcome/settings').then(r => r.data);
export const updateWelcomeSettings = (fields) => api.put('/welcome/settings', fields).then(r => r.data);
